module.exports = __webpack_public_path__ + "static/actionlist-sentence-dont-ac0da63700b704bf0470eaa77acf63b9.png";